export const USER_FORM_NAME = 'UTFORM';
export const LAST_BILL_QUERY = 'LAST_BILL_QUERY';
export const BALANCE_QUERY = 'BALANCE_QUERY';

export const SIGN_IN_FORM = 'signin';
export const PASSWORD_RECOVERY_FORM = 'passwordRecovery';
export const CHANGE_PASSWORD_FORM = 'changePassword';

export const SIGNUP_PERSONAL_INFO = 'SIGNUP_PERSONAL_INFO';
export const SIGNUP_USER_REGISTER = 'SIGNUP_USER_REGISTER';
export const SIGNUP_SERVICE_ADHERENCE = 'SIGNUP_SERVICE_ADHERENCE';
export const SIGNUP_ACCOUNT_RELATIONSHIP_VALIDATION = 'SIGNUP_ACCOUNT_RELATIONSHIP_VALIDATION';
export const SIGNUP_ADD_ACCOUNT = 'SIGNUP_ADD_ACCOUNT';
export const SIGNUP_EMAIL_VALIDATION = 'SIGNUP_EMAIL_VALIDATION';
export const SIGNUP_IDENTITY_VALIDATION = 'SIGNUP_IDENTITY_VALIDATION';
export const SIGNUP_RELATED_ACCOUNTS = 'SIGNUP_RELATED_ACCOUNTS';

export const ADD_ACCOUNT = 'ADD_ACCOUNT';
export const ACCOUNT_RELATIONSHIP_VALIDATION = 'ACCOUNT_RELATIONSHIP_VALIDATION';
export const RELATED_ACCOUNTS = 'RELATED_ACCOUNTS';
export const SERVICE_ADHERENCE = 'SERVICE_ADHERENCE';
export const PAYMENT_FORM = 'PAYMENT_FORM';
export const CANCEL_COMMENT_FORM = 'CANCEL_COMMENT_FORM';
export const CHANGE_EXPIRATION_DATE = 'changeExpirationDate';
export const CLAIMS_CONFIRM_FORM = 'CLAIMS_CONFIRM_FORM';
export const ACCOUNT_HOLDER = 'ACCOUNT_HOLDER';
export const SOCIAL_RATE_QUERY = 'SOCIAL_RATE_QUERY';
export const ACCOUNT_SELECTION = 'ACCOUNT_SELECTION';
export const CHANGE_USER_INFO = 'CHANGE_USER_INFO';
export const ACCOUNT_PAYMENT_DOCS = 'ACCOUNT_PAYMENT_DOCS';
export const USER_PAYMENT_DOCS = 'USER_PAYMENT_DOCS';
export const PAYMENT_BY_NIS = 'PAYMENT_BY_NIS';

export const CHANGE_PRIMARY_EMAIL = 'CHANGE_PRIMARY_EMAIL';
export const VALIDATE_CHANGE_PRIMARY_EMAIL = 'VALIDATE_CHANGE_PRIMARY_EMAIL';
export const PENDING_WARRANTY_DEPOSIT_QUERY = 'PENDING_WARRANTY_DEPOSIT_QUERY';
export const PENDING_FINE_AMOUNT_QUERY = 'PENDING_FINE_AMOUNT_QUERY';
export const ENTITIES_LOGIN = 'ENTITIES_LOGIN';
export const ENTITIES_COMPLAINT = 'ENTITIES_COMPLAINT';
export const TURN_USER_INFORMATION = 'TURN_USER_INFORMATION';
